import axios from '../../axiosConfig';

const parseCollection = (payload, keys = []) => {
  if (Array.isArray(payload)) return payload;
  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return [];
};

const toNumberOrNull = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const parseStats = (payload) => {
  const stats = payload?.stats || payload?.summary || payload || {};

  return {
    organizations: toNumberOrNull(stats?.organizations ?? stats?.organizations_total ?? stats?.total_organizations),
    organizationsInTrial: toNumberOrNull(
      stats?.organizations_in_trial ?? stats?.trial_organizations ?? stats?.organizations_trial
    ),
    totalNetworks: toNumberOrNull(stats?.total_networks ?? stats?.networks_total ?? stats?.networks),
    organizationsInNetworks: toNumberOrNull(
      stats?.organizations_in_networks ?? stats?.network_organizations ?? stats?.organizations_linked_to_networks
    ),
    users: toNumberOrNull(stats?.users ?? stats?.users_total ?? stats?.total_users),
    responses: toNumberOrNull(stats?.responses ?? stats?.responses_total ?? stats?.total_responses),
  };
};

export const getAdminDashboard = async () => {
  const response = await axios.get('/admin/dashboard');
  const payload = response?.data || {};

  return {
    response,
    payload,
    stats: parseStats(payload),
    surveyCoverage: payload?.survey_coverage || null,
    recentActivity: parseCollection(payload?.recent_activity, ['activities', 'items', 'events']),
    recentOrganizations: parseCollection(payload?.recent_organizations, ['organizations', 'items']),
    consultantActivity: parseCollection(payload?.consultant_activity, ['consultants', 'items', 'activity']),
  };
};
